goog.provide("shadow.js.shim.module$$launchdarkly$session_replay");
goog.provide("module$shadow_js_shim_module$$launchdarkly$session_replay");
shadow.js.shim.module$$launchdarkly$session_replay = shadow.js.nativeProvides["@launchdarkly/session-replay"] = shadow$bridge("@launchdarkly/session-replay");
module$shadow_js_shim_module$$launchdarkly$session_replay.default = shadow.js.shim.module$$launchdarkly$session_replay;
